import React, { PureComponent } from 'react';
let DateTimeField = require('react-bootstrap-datetimepicker');
import GlobalHelper from '../../../../../Common/Helpers/GlobalHelper';
import { GenericInputValidate } from 'com-gyf-webcore-userinterfacecomponents';

class FechaValor extends PureComponent {
    constructor(props) {
        super(props);
        this.changeDate = this.changeDate.bind(this);
    }

    changeDate(rule, date, callback) {
        if (date != "Invalid date") {
            const fechaFormateada = GlobalHelper.FormatDate(this.props.ingresoAjuste.fechaValor);
            const fechaFormateadaHoy = GlobalHelper.FormatDate(new Date());
            if (!date) {
                date = fechaFormateadaHoy;
            }
            let resultado = GlobalHelper.CompararIntervaloFechaDeHoy(date, fechaFormateada);
            if (resultado.estado) {
                let dateParts = date.split("/");
                let newDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
                this.props.changeDate(newDate);
                callback();
            } else {
                callback("Debe seleccionar una fecha entre el " + fechaFormateada + " y " + fechaFormateadaHoy + ".");
            }
        }
        else {
            callback("Fecha inválida.");
        }
    }

    render() {
        const { ingresoAjuste, form } = this.props;
        const { ajusteEdicion } = ingresoAjuste;
        const { getFieldDecorator, getFieldError } = form;
        let fecha = new Date();
        let mesActual = fecha.getMonth() + 1; 
        //Se agrega un "0" delante del día en el caso de que sea un día de un solo dígito y evitar que falle la llamada al servicio de Ualá. #ADT-1596
        let fechaActual = (fecha.getDate() > 9 ? fecha.getDate() : '0' + fecha.getDate()) + '/'  + (mesActual > 9 ? mesActual : '0' + mesActual) + '/'  +  fecha.getFullYear();
        let errors;
        let errorContainer = <label className="error">
            {(errors = getFieldError('fechaValor')) ? errors.join(',') : null}</label>

        let error = ((getFieldError('fechaValor')) ? true : false);

        let defaultText;
        let fechaValorEdicion = ajusteEdicion ? ajusteEdicion.FechaValor.substring(8,10) + '/' + ajusteEdicion.FechaValor.substring(5,7) + '/' + ajusteEdicion.FechaValor.substring(0,4) : null;

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-5">
                    <label className="label-primary">Fecha Valor *</label>
                    <GenericInputValidate
                        id="inputFechaValor"
                        name="inputFechaValor"
                        value={!fechaValorEdicion ? fechaActual : fechaValorEdicion}
                        className="form-control default-input"
                        disabled={true}
                    />
                    {/* {getFieldDecorator('fechaValor', {
                        rules: [{
                            validator: this.changeDate,
                        }],
                    })(
                        <DateTimeField
                            mode="date"
                            defaultText={defaultText}
                            dateTime={ingresoAjuste.fechaValor}
                            format={"DD/MM/YYYY"}
                            inputFormat={"DD/MM/YYYY"}
                        />
                    )}
                    {error && errorContainer} */}
                </div>
            </div>
        );
    }
};

export default FechaValor;